import React, { useEffect } from "react";
import { apiRequest } from "../store/allApi";
function Notify() {
  // BASE URL

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {
    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }
  // +++++++++++++++++++++++++++++
  var url_string = window.location.href; //window.location.href
  var url = new URL(url_string);
  var order_id = url.searchParams.get("order_id");
  var order_token = url.searchParams.get("order_token");

  useEffect(() => {
    deposit();
  }, []);

  const deposit = async () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(
        "deposit/notify",
        "POST",
        { order_id, order_token },
        headers,
      );
      console.log(res.data);
    } catch (e) {}
  };

  return <div>Notify</div>;
}

export default Notify;
